import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-223aab56"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "section-div" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "heading-title",
  "data-aos": "fade-up"
}, [
  /*#__PURE__*/_createElementVNode("h1", null, "Federal")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderComponent = _resolveComponent("HeaderComponent")!
  const _component_ContractVehiclesBannerComponent = _resolveComponent("ContractVehiclesBannerComponent")!
  const _component_ContractVehiclesSectionComponent = _resolveComponent("ContractVehiclesSectionComponent")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HeaderComponent, { screenName: "" }),
    _createVNode(_component_ContractVehiclesBannerComponent, {
      imageSrc: "contracts-banner.jpg",
      heading: "Contracts"
    }),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sectionsData, (section, index) => {
          return (_openBlock(), _createBlock(_component_ContractVehiclesSectionComponent, {
            key: index,
            "image-url": require(`@/assets/contract vehicles/${section.imageName}`),
            heading: section.heading,
            content: section.content,
            "data-aos": "fade-up"
          }, null, 8, ["image-url", "heading", "content"]))
        }), 128))
      ])
    ]),
    _createVNode(_component_FooterComponent)
  ]))
}